var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-img",class:[_vm.size ? `s-img-${_vm.size}` : null],on:{"click":_vm.view}},[_c('img',{attrs:{"src":_vm.src}}),(_vm.video)?_c('div',{staticClass:"s-img-play"},[_c('a-icon',{staticClass:"s-play-icon",attrs:{"type":"play-circle"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }